import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {environment} from '../../../../environments/environment';

export interface Prix {
  id?: number;
  client_id?: number;
  station_id: number;
  libelle: string;
  statut: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PrixService {
    private apiUrl = `${environment.parameters_url}api/settings/prix`;
  constructor(private http: HttpClient) {}

  getPrix(idStation: number): Observable<Prix[]> {
    return this.http.get<any>(`${this.apiUrl}/${idStation}`).pipe(
      map(response => {
        return response?.prixListe || [];
      }),
      // status 0 = navigateur (CORS / requête annulée) — ne pas casser la page clients
      catchError((error: HttpErrorResponse) => {
        if (error.status === 0) {
          console.warn(
            '[PrixService] Requête prix bloquée/annulée (status 0). L’API répond souvent correctement hors navigateur.',
            `${this.apiUrl}/${idStation}`
          );
        } else {
          console.warn('[PrixService] getPrix error', error.status, error.message);
        }
        return of([] as Prix[]);
      })
    );
  }

    getPrixById(idStation: number, idPrix: number): Observable<Prix> {
        return this.http.get<any>(`${this.apiUrl}/${idStation}/${idPrix}`).pipe(
            map(response => {
                return response.prix || response; // Adjust based on your API response structure
            }),
            catchError(this.handleError)
        );
    }

  addPrix(prix: Prix, idStation: number): Observable<Prix> {
    return this.http.post<Prix>(`${this.apiUrl}/${idStation}`, prix).pipe(
      catchError(this.handleError)
    );
  }

  updatePrix(prix: Prix, idStation: number): Observable<Prix> {
    return this.http.put<Prix>(`${this.apiUrl}/${idStation}/${prix.id}`, { libelle: prix.libelle }).pipe(
      catchError(this.handleError)
    );
  }

  updatePrixEtat(id: number, statut: boolean, idStation: number): Observable<Prix> {
    return this.http.put<Prix>(`${this.apiUrl}/${idStation}/${id}`, { statut }).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Une erreur est survenue lors de la communication avec le serveur.';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Erreur: ${error.error.message}`;
    } else {
      errorMessage = `Code d'erreur: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
